import { useQuery } from '@tanstack/react-query';

import { supabase } from '../lib/supabase';

export interface OrgRow {
  id: string;
  name: string;
}

export const orgQueryKey = ['organization', 'current'] as const;

async function fetchCurrentOrg(organizationId: string): Promise<OrgRow | null> {
  const { data, error } = await supabase
    .from('organizations')
    .select('id, name')
    .eq('id', organizationId)
    .is('deleted_at', null)
    .maybeSingle();
  if (error) throw error;
  return data;
}

export function useOrg(organizationId: string | null) {
  return useQuery({
    queryKey: [...orgQueryKey, organizationId],
    queryFn: () => {
      if (!organizationId) return Promise.resolve(null);
      return fetchCurrentOrg(organizationId);
    },
    enabled: Boolean(organizationId),
    staleTime: 5 * 60 * 1000,
  });
}
